<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl6>
            <v-card>
              <v-card-title class="pb-5">
                <!--                                    v-if="$can('transaction_create')"-->
                <!--                <v-btn :to="{name: 'pack-properties.index'}" rounded color="#A5668B" class="text-white">-->
                <!--                  <v-icon>mdi-backspace-reverse-outline</v-icon>-->
                <!--                  بازگشت-->
                <!--                </v-btn>-->
                <!--                <back-button></back-button>-->
                <!--                <v-spacer/>-->
                <!--                {{ $t($route.meta.title) }}-->
                <!--                <v-spacer/>-->
                <v-btn
                  @click="addPackProperties"
                  color="#50858B"
                  rounded
                  class="text-white"
                >
                  <v-icon>mdi-refresh</v-icon>
                  ذخیره
                </v-btn>
                <!--                            <v-card elevation="2" outlined>-->
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2">
                    <v-text-field
                      v-model="title"
                      label="عنوان "
                      dense
                      outlined
                      :error-messages="errorMessages.title"
                      :rules="rules.title"
                    ></v-text-field>
                  </v-flex>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  data() {
    return {
      errorMessages: [],
      title: null,
      price: null,
      type: null,
      types: [
        { name: "sms", value: "پیامک" },
        { name: "synonym", value: "مترداف" },
      ],
      rules: {
        title: [(v) => !!v || "عنوان را وارد کنید"],
        price: [(v) => !!v || "قیمت را وارد کنید"],
        type: [(v) => v.length > 0 || "نوع را وارد کنید"],
      },
    };
  },

  methods: {
    addPackProperties() {
      this.requestApiPost("department", {
        title: this.title,
      })
        .then((response) => {
          this.$toast.success("با موفقیت ذخیره شد");
          this.$router.push({ name: "departments.index" });
        })
        .catch((error) => {
          this.errorMessages = error.response.data.errors;
        });
    },
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },
};
</script>
